import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import AdminDashboard from './pages/admin-dashboard';
import AdminLogin from './pages/admin-login';
import Contact from './pages/contact';
import Home from './pages/home';
import BeanDetail from './pages/bean-detail';
import InteractiveFarmMap from './pages/interactive-farm-map';
import BrowseBeans from './pages/browse-beans';
import Suppliers from './pages/suppliers';
import AboutUs from './pages/about-us';
import BuyerDashboard from './pages/buyer-dashboard';
import BuyerRegistration from './pages/buyer-registration';
import BuyerLogin from './pages/buyer-login';
import BuyerAnalyticsDashboard from './pages/buyer-analytics-dashboard';
import SupplierDashboard from './pages/supplier-dashboard';
import SupplierRegistration from './pages/supplier-registration';
import SupplierApplicationStatus from './pages/supplier-application-status';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your route here */}
          <Route path="/" element={<Home />} />
          <Route path="/admin-dashboard" element={<AdminDashboard />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/home" element={<Home />} />
          <Route path="/bean-detail" element={<BeanDetail />} />
          <Route path="/interactive-farm-map" element={<InteractiveFarmMap />} />
          <Route path="/browse-beans" element={<BrowseBeans />} />
          <Route path="/suppliers" element={<Suppliers />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/buyer-dashboard" element={<BuyerDashboard />} />
          <Route path="/buyer-analytics-dashboard" element={<BuyerAnalyticsDashboard />} />
          <Route path="/buyer-registration" element={<BuyerRegistration />} />
          <Route path="/buyer-login" element={<BuyerLogin />} />
          <Route path="/supplier-dashboard" element={<SupplierDashboard />} />
          <Route path="/supplier-registration" element={<SupplierRegistration />} />
          <Route path="/supplier-application-status" element={<SupplierApplicationStatus />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
